import {
  AUTH_GET_CLIENT,
  AUTH_GET_EMAIL,
  AUTH_GET_TOKEN, AUTH_GET_USER_FULL_NAME,
  AUTH_GET_USERNAME,
  AUTH_GET_VEHICLETYPE,
  AUTH_IS_LOGGED,
  HAS_FEATURES,
  IS_AUTH_WITH_ERROR,
  IS_AUTHORIZED,
  IS_MAKING_LOGIN,
  AUTH_GET_COUNTRY
} from './types';
import { stateAuthentication } from '@/store/modules/authentication/state';
import { Client } from '@/store/modules/authentication/interfaces';
import { ClientEnum } from '@/enums/client.enum';
import { VehicleTypeEnum } from '@/enums/vehicle-type.enum';
import { features } from './constants';

export const getters = {
  [AUTH_IS_LOGGED]: (state: stateAuthentication): boolean => {
    return !!state.token;
  },
  [AUTH_GET_EMAIL]: (state: stateAuthentication): string => {
    return state.email;
  },
  [AUTH_GET_CLIENT]: (state: stateAuthentication): Client => {
    const nameClient = ClientEnum[state.idClient].replace(' | ', '_').replace(/ /g, '_').normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    const vehicleType = state.idVehicleType;
    return {
      id: state.idClient,
      name: nameClient,
      logo:
        vehicleType == VehicleTypeEnum.Motorcycle
          ? require(`../../../assets/images/motos/logo_${nameClient.toLowerCase()}.png`)
          : require(`../../../assets/images/logo_${nameClient.toLowerCase()}.png`)
    };
  },
  [AUTH_GET_USER_FULL_NAME]: (state: stateAuthentication): string => {
    return state.userFullName;
  },
  [AUTH_GET_USERNAME]: (state: stateAuthentication): string => {
    return state.username;
  },
  [AUTH_GET_TOKEN]: (state: stateAuthentication): string => {
    return state.token;
  },
  [IS_AUTHORIZED]: (state: stateAuthentication) => (feat: features): boolean => {
    return state.features.includes(feat);
  },
  [IS_AUTH_WITH_ERROR]: (state: stateAuthentication): boolean => {
    return state.loginWithError;
  },
  [IS_MAKING_LOGIN]: (state: stateAuthentication): boolean => {
    return state.makingLogin;
  },
  [AUTH_GET_VEHICLETYPE]: (state: stateAuthentication): number => {
    return state.idVehicleType;
  },
  [AUTH_GET_COUNTRY]: (state: stateAuthentication): string => {
    return state.country;
  }
};
